module.exports = __webpack_public_path__ + "static/media/jake.2fc3fb25.jpg";